import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-5735').catch(console.error);
